module.exports = __webpack_public_path__ + "static/media/dua-lipa-icon.6306e346.jpg";